if (!customElements.get('adaptive-cart-preview')) {
  class AdaptiveCartPreview extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.stage = this.querySelector('.adaptive-cart-preview-dialog__stage');
      this.image = this.querySelector('.adaptive-cart-preview-dialog__image');
      this.binding = this.querySelector('.adaptive-cart-preview-dialog__binding');
      this.closeButton = this.querySelector('.adaptive-cart-preview-dialog__close');
      this.container = this.closest('cart-items, cart-drawer');
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.restoreFocus = this.restoreFocus.bind(this);
      this.container.addEventListener('click', this.open);
      this.closeButton.addEventListener('click', this.close);
      this.dialog.addEventListener('close', this.restoreFocus);
    }

    disconnectedCallback() {
      this.container.removeEventListener('click', this.open);
      this.closeButton.removeEventListener('click', this.close);
      this.dialog.removeEventListener('close', this.restoreFocus);
    }

    open(event) {
      const trigger = event.target.closest('[data-cart-preview-src]');
      if (!trigger || !this.container.contains(trigger)) return;

      this.trigger = trigger;
      this.image.src = trigger.dataset.cartPreviewSrc;
      this.image.alt = trigger.dataset.cartPreviewAlt;
      const bindingSource = trigger.dataset.cartPreviewBinding;
      const bindingSide = trigger.dataset.cartPreviewBindingSide;
      this.stage.classList.toggle('has-binding', Boolean(bindingSource));
      if (bindingSource) {
        this.binding.src = bindingSource;
        this.binding.hidden = false;
        this.stage.dataset.bindingSide = bindingSide;
      } else {
        this.binding.removeAttribute('src');
        this.binding.hidden = true;
        delete this.stage.dataset.bindingSide;
      }
      this.dialog.showModal();
    }

    close() {
      this.dialog.close();
    }

    restoreFocus() {
      this.image.removeAttribute('src');
      this.binding.removeAttribute('src');
      this.binding.hidden = true;
      this.stage.classList.remove('has-binding');
      delete this.stage.dataset.bindingSide;
      this.trigger.focus();
    }
  }

  customElements.define('adaptive-cart-preview', AdaptiveCartPreview);
}
